/* IKD Chess Theme System - Adapted for Chess Kingdom
   Includes theme palettes and utilities for 3D piece coloring
*/

export const IKD = (() => {
  // Embedded palettes
  const PALETTES = {
    meta: {
      version: "1.0",
      notes: "IKD themes for 3D chess pieces. Colors in hex sRGB.",
      accessibility: { minBoardContrast: 3.0, coordinateContrastTarget: 4.5 }
    },
    themes: [
      {
        name: "Classic",
        bodyColor: "#FFFFFF",
        accentColor: "#FFD700",
        boardLight: "#F0D9B5",
        boardDark: "#B58863",
        frame: "#3A3F46",
        tags: ["default", "balanced"],
        accessibility: { boardContrast: 4.2, coordLegibility: "good" }
      },
      {
        name: "Instant King",
        bodyColor: "#2D5BFF",
        accentColor: "#6FA3FF",
        boardLight: "#E7E3D9",
        boardDark: "#2B2E34",
        frame: "#3A3F46",
        tags: ["cool", "modern"],
        accessibility: { boardContrast: 6.4, coordLegibility: "good" }
      },
      {
        name: "Dukes",
        bodyColor: "#7A1230",
        accentColor: "#C04764",
        boardLight: "#E7E3D9",
        boardDark: "#2B2E34",
        frame: "#3A3F46",
        tags: ["warm", "bold"],
        accessibility: { boardContrast: 6.4, coordLegibility: "good" }
      },
      {
        name: "Mono Slate",
        bodyColor: "#5A6675",
        accentColor: "#9BA7B6",
        boardLight: "#E6E9ED",
        boardDark: "#3B4250",
        frame: "#2F3440",
        tags: ["neutral", "calm"],
        accessibility: { boardContrast: 5.7, coordLegibility: "good" }
      },
      {
        name: "Gold Trim",
        bodyColor: "#2B2E34",
        accentColor: "#D6B25E",
        boardLight: "#ECE6D6",
        boardDark: "#353A40",
        frame: "#3A3F46",
        tags: ["premium"],
        accessibility: { boardContrast: 5.2, coordLegibility: "good" }
      },
      {
        name: "Emerald",
        bodyColor: "#2F6B3A",
        accentColor: "#9BCF53",
        boardLight: "#EDE9DA",
        boardDark: "#2F3B2E",
        frame: "#3E4A3F",
        tags: ["nature"],
        accessibility: { boardContrast: 8.9, coordLegibility: "excellent" }
      },
      {
        name: "Royal Purple",
        bodyColor: "#6B2D8C",
        accentColor: "#B565D8",
        boardLight: "#F0E6F6",
        boardDark: "#2E1A3D",
        frame: "#3A2547",
        tags: ["elegant"],
        accessibility: { boardContrast: 7.8, coordLegibility: "excellent" }
      },
      {
        name: "Ocean Blue",
        bodyColor: "#268BD2",
        accentColor: "#7EC8E3",
        boardLight: "#EEE8D5",
        boardDark: "#073642",
        frame: "#002B36",
        tags: ["cool", "ocean"],
        accessibility: { boardContrast: 11.7, coordLegibility: "excellent" }
      },
      {
        name: "Sunset",
        bodyColor: "#FF6B35",
        accentColor: "#FFD23F",
        boardLight: "#FFF5E1",
        boardDark: "#3D2817",
        frame: "#2A1810",
        tags: ["warm", "vibrant"],
        accessibility: { boardContrast: 10.5, coordLegibility: "excellent" }
      }
    ]
  };

  // Utilities
  const hexToRgb = (hex) => {
    const h = hex.replace('#','');
    const n = parseInt(h, 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  };

  const hexToThreeColor = (hex) => {
    const { r, g, b } = hexToRgb(hex);
    return [r / 255, g / 255, b / 255];
  };

  // Get theme by name
  function getTheme(name) {
    return PALETTES.themes.find(t => t.name === name) || PALETTES.themes[0];
  }

  // Get all themes
  function getAllThemes() {
    return PALETTES.themes;
  }

  // Apply colors to Three.js material
  function applyColorToMaterial(material, hex) {
    if (!material) return;
    const [r, g, b] = hexToThreeColor(hex);
    if (material.color) {
      material.color.setRGB(r, g, b);
    }
  }

  return {
    getTheme,
    getAllThemes,
    hexToRgb,
    hexToThreeColor,
    applyColorToMaterial,
    get palettes() { return PALETTES; }
  };
})();
